import moment from 'moment/moment';

export const dateRanges = {
  TODAY: {
    id: 'tdy',
    name: 'Today',
    value: () => ({
      start: moment().startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  PAST_WEEK: {
    id: 'pw',
    name: 'Past Week',
    value: () => ({
      start: moment().subtract(1, 'weeks').startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  PAST_TWO_WEEKS: {
    id: 'p2w',
    name: 'Past 2 Weeks',
    value: () => ({
      start: moment().subtract(2, 'weeks').startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  PAST_MONTH: {
    id: 'pm',
    name: 'Past Month',
    value: () => ({
      start: moment().subtract(1, 'months').startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  PAST_THREE_MONTHS: {
    id: 'p3m',
    name: 'Past 3 Months',
    value: () => ({
      start: moment().subtract(3, 'months').startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  PAST_SIX_MONTHS: {
    id: 'p6m',
    name: 'Past Six Months',
    value: () => ({
      start: moment().subtract(6, 'months').startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  PAST_YEAR: {
    id: 'py',
    name: 'Past Year',
    value: () => ({
      start: moment().subtract(1, 'years').startOf('day'),
      end: moment().endOf('day'),
    }),
  },

  YTD: {
    id: 'ytd',
    name: 'Year To Date',
    value: () => ({
      start: moment().startOf('year'),
      end: moment().endOf('day'),
    }),
  },

  CUSTOM: {
    id: 'cus',
    name: 'Custom Range',
  },
};
